/**
 * Inline error banner — the rose "that didn't work" strip shown inside dialogs
 * and page sections for a failed mutation. Was copy-pasted verbatim into eight
 * components; the class string is kept byte-identical to those copies.
 *
 * Renders nothing for a null/empty message, so call sites need no ternary.
 */
export interface InlineErrorProps {
  message: string | null | undefined;
}

export function InlineError({ message }: InlineErrorProps) {
  if (!message) return null;
  return (
    <p className="rounded-md bg-rose-50 px-3 py-2 text-sm font-medium text-rose-700 dark:bg-rose-950/50 dark:text-rose-300">
      {message}
    </p>
  );
}
